import { render } from "./HelloWorld.vue?vue&type=template&id=f9e6a010&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=f9e6a010&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f9e6a010"

export default script